<template>
  <div class="painel col-12 p-5">
    <div class="container p-2">
      <div class="col-md-10 offset-md-1">
        <div class="row">
          <div class="col-sm-6 col-lg-2 offset-lg-1 my-3 text-center bloco_icon animate__animated animate__delay"
            id="numero_consciente">
            <p>
              <span class="icone_eleitor rounded-circle px-4 py-3">
                <i class="bi bi-person-badge"></i>
              </span>
            </p>
            <p class="numero">
              <Contador :number="eleit.consciente" />
            </p>
            <p>Eleitor Consciente</p>
            <span class="d-flex d-lg-none col-10 offset-1"></span>
          </div>
          <div class="col-sm-6 col-lg-2 my-3 text-center bloco_icon animate__animated animate__delay"
            id="numero_multiplicador">
            <p>
              <span class="icone_eleitor rounded-circle px-4 py-3">
                <i class="bi bi-people-fill"></i>
              </span>
            </p>
            <p class="numero">
              <Contador :number="eleit.multiplicador" />
            </p>
            <p>Eleitor Multiplicador</p>
            <span class="d-flex d-lg-none col-10 offset-1"></span>
          </div>
          <div class="col-sm-6 col-lg-2 my-3 text-center bloco_icon animate__animated animate__delay" id="numero_mais">
            <p>
              <span class="icone_eleitor rounded-circle px-4 py-3">
                <i class="bi bi-person-plus-fill"></i>
              </span>
            </p>
            <p class="numero">
              <Contador :number="eleit.mais" />
            </p>
            <p>Eleitor +</p>
            <span class="d-flex d-lg-none col-10 offset-1"></span>
          </div>
          <div class="col-sm-6 col-lg-2 my-3 text-center bloco_icon animate__animated animate__delay" id="numero_lider">
            <p>
              <span class="icone_eleitor rounded-circle px-4 py-3">
                <i class="bi bi-person-raised-hand"></i>
              </span>
            </p>
            <p class="numero">
              <Contador :number="eleit.lider" />
            </p>
            <p>Eleitor Lider</p>
            <span class="d-flex d-lg-none col-10 offset-1"></span>

            <!-- Type a number: <input v-model.:number="eleit.consciente" />
          <p>{{ tweened.number.toFixed(0) }}</p> -->
          </div>
          <div class="col-sm-12 col-lg-2 my-3 text-center bloco_icon animate__animated animate__delay" id="numero_lider">
            <p>
              <span class="icone_eleitor rounded-circle px-4 py-3">
                <i class="bi bi-person-lines-fill"></i>
              </span>
            </p>
            <p class="numero">
              <Contador :number="eleit.total" />
            </p>
            <p>Total</p>
            <span class="d-flex d-lg-none col-10 offset-1"></span>

            <!-- Type a number: <input v-model.:number="eleit.consciente" />
          <p>{{ tweened.number.toFixed(0) }}</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/api';
import Contador from './Contador.vue';
// import { ref, reactive, watch } from "vue";
// // import gsap from "gsap";

// const number = ref(0);
// const tweened = reactive({
//   number: 0,
// });

// watch(number, (n) => {
//   gsap.to(tweened, { duration: 0.5, number: Number(n) || 0 });
// });

export default {
  name: "Painel",
  components: {
    Contador,
  },
  data() {
    return {
      eleit: {
        lider: 0,
        multiplicador: 0,
        mais: 0,
        consciente: 0,
        total: 0,
      }
    }
  },
  methods: {
    async eleitores() {
      this.eleit = await api.post('user/eleitores')
    }
  },
  mounted() {
    setTimeout(() => {
      this.eleitores()
    }, 1000);
  },
};
</script>

<style scoped>
p {
  display: block;
  text-align: center;
}

.painel {
  background-color: var(--cor-fundo-base);
  color: #fff;
  border-top: 3px 0 3px solid var(--cor-base-texto);
}

.bloco_icon {
  font-size: 1rem;
}

.bloco_icon span {
  border-bottom: 1px solid var(--cor-base-texto);
}

.icone_eleitor {
  color: white;
  background-color: var(--cor-base-texto);
  border: var(--cor-base-texto) 2px solid;
  font-size: 50px;
}

.numero {
  font-size: 1.6rem;
}
</style>